import { configureStore } from '@reduxjs/toolkit';
import advertsReducer from './slices/advertsSlice';
import blogReducer from './slices/blogSlice';

const store = configureStore({
  reducer: {
    adverts: advertsReducer,
    blog: blogReducer,
  }
});

export default store; 